// extracted by mini-css-extract-plugin
export default {"cover_section":"perfil-cover_cover_section__ii4J7","coverImg":"perfil-cover_coverImg__Dg3er"};